export enum controlTypes {
    TextBox = 'textbox',
    Date = 'date',
    Custom = 'custom',
    RadioButtonList = 'radiobuttonlist',
    TextArea = 'textarea',
    Checkbox = 'checkbox',
    Select = 'select',
    ImageUpload = 'imageupload',
    Display = 'display',
    CheckBoxList = 'checkboxlist',
    MeasurementUnit = 'measurementunit',
    DBSelect = 'dbselect',
    LineNumber = 'linenumber',
    jointcalculation = 'jointcalculation',
    images = 'images',
    userselect = 'userselect',
    circularslider = 'circularslider',
    tighteningdetails = 'tighteningdetails',
    alignment = 'alignment',
    jointidinput = 'jointidinput',
}
